import ArticleLayout from "../components/ArticleLayout";

export const ARTICLE = {
  path: "/jeu-responsable",
  category: null,
  title: "Jeu responsable : signaux d'alerte, limites et aide",
  description:
    "Reconnaître les signaux d'un jeu excessif, utiliser les outils de limitation, demander une interdiction volontaire et trouver de l'aide.",
  h1: "Jeu responsable",
  intro:
    "Les paris sportifs peuvent être un loisir, mais comportent des risques : endettement, isolement, dépendance. Cette page vous aide à rester maître de votre jeu et à trouver de l'aide.",
  sections: [
    {
      id: "regles-d-or",
      h2: "Les règles d'or",
      blocks: [
        {
          t: "ol",
          items: [
            "Ne jamais parier plus que ce qu'on peut se permettre de perdre.",
            "Fixer un budget et un temps de jeu avant de commencer.",
            "Ne jamais courir après ses pertes.",
            "Ne jamais parier pour résoudre un problème financier.",
            "Ne jamais jouer sous l'emprise de l'alcool, de la fatigue ou de la colère.",
            "Faire des pauses régulières.",
          ],
        },
      ],
    },
    {
      id: "signaux-d-alerte",
      h2: "Les signaux d'alerte",
      blocks: [
        {
          t: "list",
          items: [
            "Miser des sommes de plus en plus élevées.",
            "Mentir sur son jeu à son entourage.",
            "Jouer pour échapper à ses soucis.",
            "Emprunter pour jouer.",
            "Ressentir de l'irritabilité quand on ne joue pas.",
            "Négliger ses obligations, son travail, ses proches.",
          ],
        },
      ],
    },
    {
      id: "outils-de-protection",
      h2: "Les outils à utiliser",
      blocks: [
        {
          t: "list",
          items: [
            "Limites de dépôt, de mise ou de perte (chez chaque opérateur).",
            "Auto-exclusion temporaire chez un opérateur.",
            "<strong>Interdiction volontaire de jeux</strong> auprès de l'ANJ : valable chez tous les opérateurs agréés, pour une durée minimale de plusieurs années.",
            "Rappel du temps de jeu.",
          ],
        },
      ],
    },
    {
      id: "ou-trouver-de-l-aide",
      h2: "Où trouver de l'aide ?",
      blocks: [
        {
          t: "list",
          items: [
            '<strong>Joueurs Info Service : 09 74 75 13 13</strong> (appel non surtaxé) – écoute, information et orientation. Site officiel : <a href="https://www.joueurs-info-service.fr" target="_blank" rel="noopener noreferrer nofollow" class="font-semibold text-[#2BB08A] underline transition-colors hover:text-[#0B1F3A]">joueurs-info-service.fr</a>',
            "Le médecin traitant, les centres spécialisés en addictologie.",
            "Un proche de confiance.",
          ],
        },
      ],
    },
    {
      id: "proche-en-difficulte",
      h2: "Si vous êtes proche d'une personne en difficulté",
      blocks: [
        {
          t: "p",
          html: "Parlez-lui sans jugement, encouragez-la à demander de l'aide, protégez vos propres finances, et n'hésitez pas à contacter vous-même Joueurs Info Service.",
        },
      ],
    },
    {
      id: "quiz",
      h2: "Quiz « Où en suis-je avec le jeu ? »",
      blocks: [
        {
          t: "p",
          html: "Ce quiz de 8 questions vous donne une indication. Il ne remplace en aucun cas l'avis d'un professionnel.",
        },
        { t: "tool", name: "quiz" },
      ],
    },
  ],
};

export default function JeuResponsable() {
  return <ArticleLayout article={ARTICLE} />;
}
